module.exports = __webpack_public_path__ + "static/img/15.5ad477f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/15.png
// module id = aHvh
// module chunks = 0